export default __webpack_public_path__ + "static/media/6.6c5292b4.png";